import { render, staticRenderFns } from "./inspectionmanage.vue?vue&type=template&id=7b24360a&scoped=true&"
import script from "./inspectionmanage.vue?vue&type=script&lang=js&"
export * from "./inspectionmanage.vue?vue&type=script&lang=js&"
import style0 from "./inspectionmanage.vue?vue&type=style&index=0&id=7b24360a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24360a",
  null
  
)

export default component.exports